import L from 'leaflet';

export const MAP_STYLES = {
  SATELLITE: {
    id: 'satellite',
    label: 'Satellite',
    // Google Satellite Hybrid (includes labels)
    url: 'https://{s}.google.com/vt/lyrs=y&x={x}&y={y}&z={z}',
    subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
    attribution: '© Google',
  },
  OUTDOORS: {
    id: 'outdoors',
    label: 'Outdoors',
    // Google Terrain (includes labels and terrain shading)
    url: 'https://{s}.google.com/vt/lyrs=p&x={x}&y={y}&z={z}',
    subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
    attribution: '© Google',
  },
  NORMAL: {
    id: 'normal',
    label: 'Normal',
    // Google Roadmap (standard view)
    url: 'https://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}',
    subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
    attribution: '© Google',
  }
};

export const getMapStyleUrl = (styleId: string): string => {
  if (styleId === 'satellite') return MAP_STYLES.SATELLITE.url;
  if (styleId === 'outdoors') return MAP_STYLES.OUTDOORS.url;
  return MAP_STYLES.NORMAL.url;
};

export const getMapAttribution = (styleId: string): string => {
  if (styleId === 'satellite') return MAP_STYLES.SATELLITE.attribution;
  if (styleId === 'outdoors') return MAP_STYLES.OUTDOORS.attribution;
  return MAP_STYLES.NORMAL.attribution;
};

export const getMapStyleOptions = (styleId: string): L.TileLayerOptions => {
  const options: L.TileLayerOptions = {
    maxZoom: 20,
    subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
  };

  if (styleId === 'satellite') {
    options.attribution = MAP_STYLES.SATELLITE.attribution;
  } else if (styleId === 'outdoors') {
    options.attribution = MAP_STYLES.OUTDOORS.attribution;
  } else {
    options.attribution = MAP_STYLES.NORMAL.attribution;
  }

  return options;
};

/**
 * Legacy support for scripts expecting MapLibre style objects
 */
export const getMapStyle = (styleId?: string): any => {
  return createOSMStyle();
};

export const getFallbackStyle = (styleId?: string): any => {
  return createOSMStyle();
};

function createOSMStyle(): any {
  return {
    version: 8,
    name: 'OpenStreetMap',
    sources: {
      osm: {
        type: 'raster',
        tiles: ['https://tile.openstreetmap.org/{z}/{x}/{y}.png'],
        tileSize: 256,
        attribution: '© OpenStreetMap contributors',
      }
    },
    layers: [
      { id: 'osm', type: 'raster', source: 'osm' }
    ]
  };
}
